import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import login from "./pages/login";
import signup from "./pages/signup";
import home from "./pages/home";
import intake from "./pages/intake";
import success from "./pages/success";
import learningStyles from "./pages/learningStyles.js";
import learningStylesHK from "./pages/learningStylesHK.js";
import mathAnxiety from "./pages/mathAnxiety.js";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
// import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@material-ui/core";
import "./index.css";
import { colors } from "./colors.js";

const theme = createMuiTheme({
  typography: {
    fontFamily: ["Manrope", '"Helvetica Neue"', "Arial", "sans-serif"].join(
      ","
    ),
  },
  palette: {
    primary: {
      light: colors.color1.secondary[0],
      main: colors.color1.primary,
      dark: colors.color1.secondary[1],
      contrastText: "#fff",
    },
    secondary: {
      light: colors.color2.secondary[0],
      main: colors.color2.primary,
      dark: colors.color2.secondary[1],
    },
    error: {
      light: colors.color4.secondary[1],
      main: colors.color4.secondary[0],
      dark: colors.color4.primary,
    },
    warning: {
      light: colors.color2.secondary[1],
      main: colors.color2.primary,
      dark: colors.color2.secondary[0],
    },
    info: {
      light: colors.color5.secondary[1],
      main: colors.color5.secondary[0],
      dark: colors.color5.primary,
    },
    success: {
      light: colors.color3.primary,
      main: colors.color3.secondary[0],
      dark: colors.color3.secondary[1],
    },
  },
});

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <Router>
        <div>
          <Switch>
            <Route exact path="/mathAnxiety" component={mathAnxiety} />
            <Route exact path="/learningStyles" component={learningStyles} />
            <Route
              exact
              path="/learningStylesHK"
              component={learningStylesHK}
            />
            <Route exact path="/login" component={login} />
            <Route exact path="/success" component={success} />
            <Route exact path="/signup" component={signup} />
            <Route exact path="/teachers" component={home} />
            <Route
              exact
              path="/level1"
              render={() => {
                window.location.href = "levels/level1.html";
              }}
            />
            <Route
              exact
              path="/level2"
              render={() => {
                window.location.href = "levels/level2.html";
              }}
            />
            <Route
              exact
              path="/level3"
              render={() => {
                window.location.href = "levels/level3.html";
              }}
            />
            <Route
              exact
              path="/level4"
              render={() => {
                window.location.href = "levels/level4.html";
              }}
            />
            <Route
              exact
              path="/level5"
              render={() => {
                window.location.href = "levels/level5.html";
              }}
            />
            <Route exact path="/" component={intake} />
          </Switch>
        </div>
      </Router>
    </MuiThemeProvider>
  );
}

export default App;
